<div class="bg-white m-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-end" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 class="text-secondary pb-2">{{ title }}</h3>
  </div>
  <div class="modal-body">
    <div>
      @if (options.topText) {
        <div class="mb-2">
          <small
            ><strong>{{ options.topText }}</strong></small
            >
          </div>
        }
        @if (options.fileLink) {
          <div class="mb-2">
            <a [href]="options.fileLink" target="_blank">{{ options.fileLink.split('/').pop() }}</a>
          </div>
        }
        @if (options.approval) {
          <div class="mb-3 mb-3">
            <div class="form-check">
              <input
                id="approval"
                type="checkbox"
                class="form-check-input"
                [(ngModel)]="approved"
                name="approval"
                [class.is-invalid]="submitted && !approved"
                />
              <label for="approval" class="form-check-label">Lu et approuvé</label>
              @if (submitted && !approved) {
                <small class="form-text text-danger">La mention "Lu et approuvé" est requise.</small>
              }
            </div>
          </div>
        }
        <div class="mx-auto" style="border: 1px solid red" [style.width]="width + 'px'" [style.height]="height + 'px'">
          <ng-signaturepad #signaturePad [width]="width" [height]="height"></ng-signaturepad>
        </div>
        @if (!isEmpty) {
          <div class="d-flex flex-row-reverse px-3">
            <button type="button" role="button" class="shadow-none btn btn-link text-decoration-none" (click)="clear()">Effacer</button>
          </div>
        }
        @if (options.bottomText) {
          <div class="mt-1">
            <small
              ><strong>{{ options.bottomText }}</strong></small
              >
            </div>
          }
        </div>
        <div class="row mt-3">
          <div class="d-grid col-6 p-0 pe-1">
            <button class="btn btn-secondary d-flex justify-content-center" type="button" (click)="cancel()">Annuler</button>
          </div>
          <div class="d-grid col-6 p-0 ps-1">
            <button class="btn btn-primary d-flex justify-content-center" type="button" [disabled]="isEmpty" (click)="accept()">Valider</button>
          </div>
        </div>
      </div>
    </div>
